import React from 'react';
import ScreenComponent from './ScreenComponent';
import { Confirmation } from '../Confirmation';
import axios from 'axios';
import { config } from '../../app/config';
import { connect } from "react-redux";
import { preloaderShow, preloaderHide, alert, topbarUpdate, openLink } from '../../actions';
import { NotesList } from "./note/NotesList";
import '../../styles/elements/screen.scss';
import '../../styles/screens/note.scss';
import TranslationService from "../../app/services/TranslationService";
import {Button} from "../icymat-design/Button";
import {Textarea} from "../icymat-design/Textarea";
import JoditEditor from "jodit-react";
import {BooksList} from "./note/BooksList";
import {NewBookDialog} from "./note/NewBookDialog";


class NoteClass extends ScreenComponent
{
    joditConfig = {
        allowEmptyParagraph: false,
        addNewLine: false,
        placeholder: '',//TranslationService.trans(this.props.language, 'common.content'),
        editorCssClass: 'note-editor',
        toolbarAdaptive: false,
        toolbarSticky: false,
        buttons: [
            'paragraph',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            // '|',
            // 'left',
            // 'center',
            // 'right',
            // 'justify',
            '|',
            // 'sup',
            // 'sub',
            // '|',
            'ul',
            'ol',
            // 'table'
        ],
        readonly: (this.props.readonly === undefined ? false : this.props.readonly),
        statusbar: false,
        cleanHTML: {
            replaceNBSP: true,
            fillEmptyParagraph: false,
            removeEmptyElements: true,
            allowTags: 'p,br,strong,b,em,i,u,s,a[href],ul,ol,li,h1,h2,h3,h4,h5,h6,img'
        },
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false
    };

    constructor(props)
    {
        super(props);

        this.state = {
            jodit: this.props.flags?.app_note_jodit,
            books: [],
            notes: [],
            note_id: '',
            book_id: null,
            content: '',
            delete_note: null,
            new_book: null
        };
    };

    getScreenName() {
        return 'note';
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.view !== this.getScreenName() && this.props.view === this.getScreenName()) {
            this.loadData(this.state.book_id);
            this.props.topbarUpdate({
                action1: this.buttons('action1'),
                action2: null,
                actionBig: null
            });

            this.openElementFromLink();
        }
    };

    openElementFromLink = () => {
        if (this.props.link !== null) {
            const noteToOpen = this.props.link;
            this.props.openLink(null);
            this.openNote(noteToOpen, true);
        }
    }

    handleContentChange = (event) => {
        this.setState({content: event.target.value});
    };

    loadData = (bookId = null) => {
        this.setState({jodit: this.props.flags?.app_note_jodit});

        this.props.preloaderShow();
        let that = this;

        let loaded = 0;
        let verifyLoaded = function() {
            loaded++;
            if (loaded === 2) {
                that.props.preloaderHide();
            }
        }

        axios.get(config.apiAddress + '/app/note/list?book=' + (bookId === null ? '' : bookId))
            .then(function (response) {
                that.setState({notes: response.data});
                verifyLoaded()
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'note.actions.open_failed'));
            });

        axios.get(config.apiAddress + '/app/note/books')
            .then(function (response) {
                that.setState({books: response.data});
                verifyLoaded()
            }).catch(function(error) {
                that.props.alert(TranslationService.trans(that.props.language, 'note.actions.open_failed'));
            });
    };

    openBook = (bookId, note = null) => {
        this.setState({
            new_book: false,
            book_id: bookId,
            note_id: note !== null ? note.id : '',
            content: note !== null ? note.note : ''
        });
        this.loadData(bookId);
    }

    openNote = (noteId, refreshBooks) => {
        const htmlToPlainText = function (html) {
            if (!html) return '';

            const noScripts = html.replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, '');

            const withNewlines = noScripts
                .replace(/<\s*br\s*\/?>/gi, '\n')
                .replace(/<\/\s*p\s*>/gi, '\n');

            const tmp = document.createElement('div');
            tmp.innerHTML = withNewlines;
            let text = tmp.textContent || tmp.innerText || '';

            text = text
                .replace(/\u00A0/g, ' ')
                .replace(/\r?\n[ \t]*/g, '\n')
                .replace(/\n{2,}/g, '\n')
                .replace(/[ \t]{2,}/g, ' ')
                .trim();

            return text;
        }

        let that = this;
        if (noteId !== null) {
            this.props.preloaderShow();

            axios.get(config.apiAddress + '/app/note/' + noteId)
                .then(function (response) {
                    let content = response.data.note;
                    if (that.state.jodit && content[0] !== '<') {
                        content = content.split(/\r?\n/)
                            .map(line => line.trim() ? `<p>${line}</p>` : "")
                            .join("");
                    } else if (!that.state.jodit && content[0] === '<') {
                        content = htmlToPlainText(content);
                    }

                    that.setState({
                        book_id: response.data.book,
                        note_id: noteId,
                        content: content,
                    });
                    that.props.topbarUpdate({
                        action1: that.buttons('action1'),
                        action2: that.buttons('action2'),
                        actionBig: null
                    })
                    that.props.preloaderHide();

                    if (refreshBooks) {
                        that.props.preloaderShow();
                        that.openBook(response.data.book, response.data);
                    }
                }).catch(function(error) {
                    that.setState({
                        note_id: '',
                        content: ''
                    });
                    that.props.preloaderHide();
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.open_failed'));
                });
        }
    };

    cancel = () => {
        this.props.topbarUpdate({
            action1: this.buttons('action1'),
            action2: null,
            actionBig: null
        })
        this.setState({note_id: '', content: ''});
    };

    save = () => {
        let that = this;
        this.props.preloaderShow();

        if (this.state.note_id === '') {
            axios.post(config.apiAddress + '/app/note', {content: that.state.content, book: that.state.book_id})
                .then(function (response) {
                    that.cancel();
                    that.loadData(that.state.book_id);
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.saved'));
                }).catch(function(error) {
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.saved_failed'));
                    that.props.preloaderHide();
                });
        } else {
            axios.put(config.apiAddress + '/app/note/' + that.state.note_id, {content: that.state.content})
                .then(function (response) {
                    that.cancel();
                    that.loadData(that.state.book_id);
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.saved'));
                }).catch(function(error) {
                    that.props.alert(TranslationService.trans(that.props.language, 'note.actions.saved_failed'));
                    that.props.preloaderHide();
                });
        }
    };

    deleteNote = () => {
        if (this.state.note_id === '') {
            return;
        }

        this.setState({delete_note: config.apiAddress + '/app/note/' + this.state.note_id});
    };

    deleteNoteSuccess = (response, address) => {
        this.cancel();
        this.loadData(this.state.book_id);
        this.props.alert(TranslationService.trans(this.props.language, 'note.actions.deleted'));
        this.setState({delete_note: null});
    };

    deleteNoteError = (error, address) => {
        this.props.alert(TranslationService.trans(this.props.language, 'note.actions.deleted_failed'));
    };

    buttons = (type) => {
        if (type === 'action1') {
            return [
                {
                    'type': 'button',
                    'color': 'main',
                    'secondary': false,
                    'icon': 'imd-icon imd-icon-floppy-disk',
                    'text': null,
                    'onClick': () => this.save()
                },
                {
                    'type': 'button',
                    'color': 'main',
                    'secondary': true,
                    'icon': 'imd-icon imd-icon-book',
                    'text': null,
                    'onClick': () => this.setState({new_book: true})
                }
            ];
        }

        return [
            {
                'type': 'button',
                'color': 'accent',
                'secondary': true,
                'icon': 'imd-icon imd-icon-xmark',
                'text': null,
                'onClick': () => this.cancel()
            },
            {
                'type': 'button',
                'color': 'red',
                'secondary': true,
                'icon': 'imd-icon imd-icon-trash',
                'text': null,
                'onClick': () => this.deleteNote()
            }
        ];
    }

    render() {
        return (
            <div className="screen screen-note" id="screen-note" style={this.getStyle()}>
                <div className="content imd-text-accent">
                    <div className="imd-container-fluid">
                        <div className="imd-row">
                            <div className="imd-col-12 imd-col-md-2 imd-col-lg-2">
                                <BooksList
                                    className="imd-hide-sm imd-hide-xl"
                                    books={this.state.books}
                                    bookId={this.state.book_id}
                                    openElement={this.openBook}
                                    language={this.props.language}
                                />

                                <div className="imd-hide-xs imd-hide-sm" style={{display: this.props.flags?.topbar !== true ? 'block' : 'none'}}>
                                    <Button
                                        text={TranslationService.trans(this.props.language, 'note.new_book')}
                                        color={'main'}
                                        secondary={true}
                                        onClick={() => this.setState({new_book: true})}
                                    />
                                </div>
                            </div>

                            <div className="imd-col-12 imd-col-md-2 imd-col-lg-2">
                                <NotesList
                                    className="imd-hide-sm imd-hide-xl"
                                    notes={this.state.notes}
                                    noteId={this.state.note_id}
                                    openElement={this.openNote}
                                    language={this.props.language}
                                />
                            </div>

                            <div className="imd-col-12 imd-col-md-8 imd-col-lg-8">
                                <div className="actions" style={{display: this.props.flags?.topbar !== true ? 'block' : 'none'}}>
                                    <Button
                                        text={TranslationService.trans(this.props.language, 'common.save')}
                                        color={'main'}
                                        onClick={() => this.save()}
                                    />

                                    <Button
                                        text={TranslationService.trans(this.props.language, 'common.cancel')}
                                        color={'accent'}
                                        secondary={true}
                                        onClick={this.cancel}
                                        display={this.state.note_id !== ''}
                                    />

                                    <Button
                                        text={TranslationService.trans(this.props.language, 'common.delete')}
                                        color={'red'}
                                        secondary={true}
                                        onClick={this.deleteNote}
                                        display={this.state.note_id !== ''}
                                    />
                                </div>

                                <hr className="imd-border-color-140-accent" style={{display: this.props.flags?.topbar !== true ? 'block' : 'none'}} />

                                <div className={"note"}>
                                    {this.state.jodit ?
                                        <JoditEditor
                                            // ref={editor}
                                            value={this.state.content}
                                            config={this.joditConfig}
                                            tabIndex={1} // tabIndex of textarea
                                            onBlur={newContent => this.setState({'content': newContent})} // preferred to use only this option to update the content for performance reasons
                                            // onChange={newContent => this._changeText(newContent)}
                                        />
                                    :
                                        <Textarea
                                            value={this.state.content}
                                            placeholder={TranslationService.trans(this.props.language, 'common.content')}
                                            onChange={this.handleContentChange}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <Confirmation
                        address={this.state.delete_note}
                        onSuccess={this.deleteNoteSuccess}
                        onError={this.deleteNoteError}
                        onCancel={() => this.setState({delete_note: null})}
                    />

                    <NewBookDialog
                        show={this.state.new_book}
                        onSuccess={(bookId) => this.openBook(bookId)}
                        closeEvent={() => this.setState({new_book: false})}
                        onError={() => this.setState({new_book: false})}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        email: state.login.email,
        device: state.login.device,
        view: state.view,
        language: TranslationService.getLanguage(state.user),
        flags: state.user?.flags,
        link: state.link
    }
};

export const NoteScreen = connect(mapStateToProps, {preloaderShow, preloaderHide, alert, topbarUpdate, openLink})(NoteClass);
